<template>
    <v-expansion-panels v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header :class="classColor">
                {{ title }}
                <template v-slot:actions>
                    <v-icon color="white">
                        $expand
                    </v-icon>
                </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
                <slot></slot>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        barClass: {
            type: String,
            default: "grey white--text mb-4",
        },
        openByDefault: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            panel: this.openByDefault ? 0 : undefined,
        };
    },

    computed: {
        classColor() {
            return `${this.barClass}`;
        },
    }
};
</script>